import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "pb-8",
  id: "footer"
}
const _hoisted_2 = { class: "block justify-between md:flex" }
const _hoisted_3 = { class: "text-gray-200 bold text-xs text-center md:text-left" }
const _hoisted_4 = {
  key: 0,
  class: "privacy-cookie block text-center align-middle items-center md:flex md:text-left"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "text-gray-200 bold text-xs text-right pr-2",
  href: "https://app.termly.io/document/privacy-policy/8ca4d8ea-2c32-48f2-8eb9-875556506e0d",
  target: "_blank"
}, "Privacy policy", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "text-gray-200 bold text-xs text-right",
  href: "https://app.termly.io/document/cookie-policy/741c2f87-feee-4576-9ca4-0c502be0c432",
  target: "_blank"
}, "Cookies policy", -1)
const _hoisted_7 = { class: "block m-2" }
const _hoisted_8 = {
  class: "m-auto border-2 border-white text-white bg-white rounded-full uppercase button-text px-4 py-2 cursor-pointer truncate special-download font-bold gradient-animated text-center hover:bg-gray-300",
  href: "https://aitattoo62.com",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, "Copyright " + _toDisplayString(new Date().getFullYear()) + " Inksquad. All rights reserved.", 1),
      (!_ctx.isEmbeddedInIpadView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "text-gray-200 bold text-xs text-right pr-2",
              to: "/terms-and-conditions"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('components.footer.termsandconditions')), 1)
              ]),
              _: 1
            }),
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('components.top-bar.get-inksquad-ai')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}